/**
 * Centralised defaults for Mini TV so we don't scatter arbitrary fallbacks.
 * Used when API/event payload has no results yet (e.g. presentation phase) or optional score lookup.
 */

/** Fallback team ids for baseball presentation when event results don't yet have team data. */
export const FALLBACK_TEAM1_ID = '1';
export const FALLBACK_TEAM2_ID = '681';

/** Default football score when no score has been reported yet. */
export const DEFAULT_FOOTBALL_SCORE = { home: 0, away: 0 };
